import React from 'react';
import './Footer.css';
import logo from "../../Images/Logo.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Left section with logo and description */}
        <div className="footer-left">
          <a href="/">
            <img src={logo} loading="lazy" alt="Company Logo" className="footer-logo" />
          </a>
          <p className="footer-description">
            📚 Otter Tutors – Unlock Your Potential! 🌟 Expert online tutoring for K1-K12 and IIT JEE/NEET prep. Master Math, Science, English, and more with live classes, 1-on-1 doubt sessions, and personalized guidance. 🎓 Fun, flexible, and effective learning – anytime, anywhere! 🚀
          </p>
        </div>

        {/* Center section with Company Info, Links, and others */}
        <div className="footer-center">
          <h3>Company</h3>
          <div className="footer-links">
            <a href="/about-us" className="footer-link">About Us</a>
            <a href="/contact-us" className="footer-link">Contact Us</a>
            <a href="/careers" className="footer-link">Careers</a>
            <a href="/batches" className="footer-link">Batches</a>
          </div>
        </div>

        {/* Right section with social media icons */}
        <div className="footer-right">
          <h3>Follow Us On</h3>
          <div className="social-icons">
            <a href="https://www.facebook.com/share/1JLHDzGGGf/" target="_blank" rel="noopener noreferrer" className="social-icon facebook">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://www.linkedin.com/company/otter-tutors/" target="_blank" rel="noopener noreferrer" className="social-icon linkedin">
              <i className="fab fa-linkedin"></i>
            </a>
            <a href="https://www.instagram.com/ottertutors/" target="_blank" rel="noopener noreferrer" className="social-icon instagram">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.youtube.com/@OtterTutors" target="_blank" rel="noopener noreferrer" className="social-icon youtube">
              <i className="fab fa-youtube"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Bottom section with contact details */}
      <div className="footer-bottom">
        <div className="footer-left-bottom">
          <h4>Connect With Us</h4>
          <p>📧 Email: <a href="mailto:support@ottertutors.com" style={{color:'white' , textDecoration:'none'}}>support@ottertutors.com</a></p>
          <p>📞 Phone: 9509937969 / 7316981837</p>
        </div>

        <hr />

        <div className="footer-center-bottom">
          <p>© 2024 Otter Tutors. All rights reserved.</p>
        </div>

        <div className="footer-right-bottom">
          <a href="/terms-of-use" className="footer-link">Terms and Condition</a> |&nbsp;
          <a href="/privacy-policy" className="footer-link">Privacy Policy</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
